/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Cancel_ShipmentInputs */

const vi_carrier_cancel_shipment = /** @type {(inputs: Carrier_Cancel_ShipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huỷ vận đơn`)
};

/**

* @param {Carrier_Cancel_ShipmentInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_cancel_shipment = /** @type {((inputs?: Carrier_Cancel_ShipmentInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Cancel_ShipmentInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_cancel_shipment(inputs)
});